import { TranslatePipe } from '../../../filters/translate.pipe';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../../utils/session.service';
import AngularHelperService from '../../../services/angular-helper.service';

@Component({
	standalone: true,
	selector: 'benu-thank-you-page',
	templateUrl: './benu-thank-you-page.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export default class BenuThankYouPageComponent implements OnInit, OnDestroy {
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	vm: any = undefined;
	watcher: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		var currentSession = this.session.getSession();
		this.watcher = this.angularHelperService.createInterval(() => {
			var newSession = this.session.getSession();
			if (!this.angularHelperService.isEqual(newSession, currentSession)) {
				this.handleSessionChange(newSession, currentSession);
				currentSession = Object.assign({}, newSession);
			}
		}, 300);
		
		window.sessionStorage.removeItem("THIRD_PARTY_RENEWAL");
		window.sessionStorage.removeItem("LOC");
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	handleSessionChange(newSess, oldSess) {
		if (this.angularHelperService.equals(newSess, oldSess) || !newSess) return;
		this.vm.user = newSess.user;
	}
	
}